
export class AdTargetLookup {

    constructor(public lookup: any, public kvKey = '_kvs') { }

    public byHost(host: string, key?: string) {
        const item = host.replace('www.', '').split('.').reverse()
            .reduce((data: any, k: string) => data && data[k] || undefined, this.lookup)

        if (key) {
            try {
                return item[this.kvKey][key]
            } catch {
                return undefined
            }
        }

        return item
    }
}
